module.exports = __webpack_public_path__ + "img/lang-ar.7c163d54.svg";